import { render, staticRenderFns } from "./CreateKaryawan.vue?vue&type=template&id=60936d4e"
import script from "./CreateKaryawan.vue?vue&type=script&lang=js"
export * from "./CreateKaryawan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports